var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

if ($("#preloader").length > 0) {
  $(window).on("load", function () {
    $("#preloader")
      .delay(1000)
      .fadeOut(1000, function () {
        if ($(".preloader-overflow").length > 0) {
          $("body").removeClass("preloader-overflow");
        }
      });
  });
}
 
$(document).ready(function () {
    var Dwin = $(this); 
    if (Dwin.width() >= 769) {
      slickVeritcal();
    }
  else
    {
      slickHorizontal();
    }    
});
 
$(window).on('resize', function(){
    var win = $(this); 
    if (win.width() >= 769) {
      slickVeritcal();
    }
  else
    {
      slickHorizontal();
    }    
});

function slickVeritcal(retry) {
  var thumbs = $(".media-slick-slider  .thumbnail-list");
  if (!thumbs.length) return;
  if (typeof $.fn.slick === "undefined") {
    retry = retry || 0;
    if (retry < 20) setTimeout(function () { slickVeritcal(retry + 1); }, 250);
    return;
  }
  thumbs.not(".slick-initialized").slick({
    vertical: true,
    verticalSwiping: true,
    slidesToShow: 4,
    slidesToScroll: 1,
  });
}
function slickHorizontal() {
  if (typeof $.fn.slick === "undefined") return;
  var thumbs = $(".media-slick-slider  .thumbnail-list.slick-initialized");
  if (thumbs.length) thumbs.slick("unslick");
}

$(window).scroll(function () {
  if ($(window).width() > "1024") {
    if ($(window).scrollTop() >= 500) {      
      $(".sticky-bar").addClass("active");
    } else {       
      $(".sticky-bar").removeClass("active");
    }
  }
});

$(window).scroll(function () {
  if ($(window).width() < "1024") {
    if ($(window).scrollTop() >= 900) {      
      $(".sticky-bar").addClass("active");
    } else {       
      $(".sticky-bar").removeClass("active");
    }
  }
});

$(document).ready(function () {
  $("#recently").click(function () {
    $("#recently-viewed-products").slideToggle(500);
  });
});

var afterInfiniteLoaded = function afterInfiniteLoaded() {
  $(".loading-image").removeClass("loading-image").addClass("loaded-image");
};
if ($(".pagination-method-loadmore_btn").length > 0) {
  var AjaxMethod = "click";
} else {
  var AjaxMethod = "scroll";
}
if ($(".collection #AjaxinatePagination").length > 0) {
  var endlessScroll = new Ajaxinate({
    container: ".AjaxinateContainer",
    pagination: "#AjaxinatePagination",
    method: AjaxMethod,
    offset: 0,
    callback: afterInfiniteLoaded,
  });
}

InitCustomFunctions();
function InitCustomFunctions() {
  $('.facet-checkbox input:checkbox').each(function () {
  if($(this).is(':checked')){
       $(this).parent('.facet-checkbox').addClass('active');
    }     
  });
  

  
  if ($(".toggleFilter").length > 0) {
    const filter = document.querySelector(".toggleFilter");
    const sidebar = document.querySelector(".facets-vertical");
    const closeDiv = document.querySelector(".close-sidebar");

    filter.addEventListener("click", () => {
      filter.classList.toggle("active");
      sidebar.classList.toggle("open");
      $("body").addClass("overflow-hidden");
      $("body").addClass("filter-clicked");
    });

    closeDiv.addEventListener("click", () => {
      filter.classList.remove("active");
      sidebar.classList.remove("open");
      $("body").removeClass("overflow-hidden");
      $("body").removeClass("filter-clicked");
    });
  }

  //product page color variant to select thumbnail img change color_variants
  if ($(".show-grouped__variant").length > 0) {
    $('input:radio[name="Color"]').click(function () {
      const cvariant = $(this).val();
      $(this).closest('fieldset').find('.form__label span').text(cvariant);
      $('input:radio[name="Color"]')
        .next(".swatch-element")
        .removeClass("clicked");
      $(this).next(".swatch-element").addClass("clicked");
      $(".slick-list").addClass("height_fix");
      $(".thumbnail-list__item").each(function () {
        const variant_val = $(this).find("img").attr("alt");
        if (cvariant == variant_val) {
          $(this).addClass("show");
          $(this).removeClass("hidden");
        } else {
          $(this).addClass("hidden");
          $(this).removeClass("show");
        }
      });
    });
  }

  //     Item swatch trigger start
  $(document).on("click", ".color-values a", function () {
    if ($(this).hasClass("active")) {
      $(this).closest('.variant-option-color').find('.color-values a').removeClass("active");
    } else {
      $(this).closest('.variant-option-color').find('.color-values a').removeClass("active");
      $(this).addClass("active");
    }
  });

  $(document).on("click", ".size-values a", function () {
    if ($(this).hasClass("active")) {
      $(".size-values a").removeClass("active");
      $(this)
        .parents(".products")
        .find(".variant-option-size .size-values")
        .removeClass("active");
    } else {
      $(".size-values a").removeClass("active");
      $(this).addClass("active");
      $(this)
        .parents(".products")
        .find(".variant-option-size .size-values")
        .removeClass("active");
    }
  });
  $("body").on("click", ".color-values-plus a", function (e) {
    $(this)
      .parents(".variant-option-color")
      .find(".show-on-click")
      .css("display", "flex");
    $(this).parents(".color-values-plus").css("display", "none");
    e.preventDefault();
  });

  $("body").on("click", ".swatch-element.color", function () {
    $(this).next("label").find("i");
  });
  $("body").on("click", ".swatch span", function () {
    var featuredMedia = $(this)
      .parents(".card-wrapper")
      .find(".card__inner .motion-reduce")
      .attr("srcset", $(this).data("image"));
    $(this)
      .parents(".card-wrapper")
      .find(".card__inner .motion-reduce")
      .attr("srcset", $(this).data("image"));

    if ($(this).parents(".swatch").hasClass("color")) {
      const variant = $(this).data("id");
      $(this).parents(".product-grid").find(".variant-push").val(variant);

      var swatch_item = $(this).data("variant-item");

      $(this)
        .parents(".product-grid")
        .find(".variant-option-size .size-values")
        .removeClass("active");

      $(this)
        .parents(".product-grid")
        .find(".variant-option-size .swatch")
        .each(function () {
          var swatch_size_vars = $(this).find("span").data("variant-title");
          swatch_size_vars = swatch_size_vars.split("/");
          swatch_size_vars = $.map(swatch_size_vars, $.trim);
          swatch_size_vars = $.map(swatch_size_vars, function (n) {
            return n.toLowerCase();
          });
          swatch_size_vars = $.map(swatch_size_vars, function (n) {
            return n.replace(/ /g, "-");
          });

          if ($.inArray(swatch_item, swatch_size_vars) >= 0) {
            $(this).parent(".size-values").toggleClass("active");
          }
        });
    }

    if ($(this).parents(".swatch").hasClass("size")) {
      var variant = $(this).data("id");
      $(this).parents(".product-grid").find(".variant-push").val(variant);
    }
  });

  //     Item swatch trigger end
  $(".custom-product-grid li").click(function () {
    var classNames ="list-view-filter grid--2-col-desktop grid--3-col-desktop grid--4-col-desktop grid--5-col-desktop grid--6-col-desktop align-1-column align-2-column align-3-column align-4-column align-5-column";
    var getCols = $(this).data("cols");
    var getVal = $(this).data("val");
    var getVal = "align-"+getVal+"-column";    
    $(".custom-product-grid li").removeClass("active");
    $(this).addClass("active");
    $("ul#product-grid").removeClass(classNames).addClass(getCols+" "+getVal);
  });
  if ($(".filter-buttons").length > 0) {
    const viewExists = document.querySelector(".grid-view-button");
    if (viewExists.classList.contains("layout-mode")) {
      const listViewButton = document.querySelector(".list-view-button");
      const gridViewButton = document.querySelector(".grid-view-button");
      const list = document.querySelector("ul.view-mode");
      const gridviewlist = document.querySelector(".custom-product-grid");

      listViewButton.onclick = function () {
        listViewButton.classList.add("active");
        gridViewButton.classList.remove("active");
        list.classList.remove("grid-view-filter");
        list.classList.add("list-view-filter");
        gridviewlist.classList.add("hidden");
      };

      gridViewButton.onclick = function () {
        listViewButton.classList.remove("active");
        gridViewButton.classList.add("active");
        list.classList.remove("list-view-filter");
        list.classList.add("grid-view-filter");
        gridviewlist.classList.remove("hidden");
      };
    }
  }
  if ($("#swiper-sidebar-carousel").length > 0) {
    var swiper = new Swiper("#swiper-sidebar-carousel", {
      navigation: {
        nextEl: "#swiper-sidebar-next",
        prevEl: "#swiper-sidebar-prev",
      },
    });
  }

  setTimeout(function () {
    $(".loading-image").removeClass("loading-image").addClass("loaded-image");
  }, 2000);

  const radioButtons = document.querySelectorAll('.dt-sort__container input[name="sort_by"]');
  const optionSummary = document.querySelector('.dt-sort__container .facets__summary-label');
  var selectedRadioButton;
  for (const radioButton of radioButtons) {
    if (radioButton.checked) {
      selectedRadioButton = radioButton.getAttribute("data-value");      
      optionSummary.innerHTML = selectedRadioButton;    
    }
  }
  
}


//FBT ul li select box
$("ul.custom-select").on("click", "li:not(.init)", function () {
  var selectedVal = $(this).data("option-value");  
  $(this)
    .parents(".fbt-product__meta")
    .find(".selectVariant option")
    .attr("selected", false);
  $(this)
    .parents(".fbt-product__meta")
    .find(".selectVariant option[value=" + selectedVal + "]")
    .attr("selected", "selected")
    .trigger("change");
});

$("ul.custom-select").on("click", ".init", function () {
  $(this).closest("ul.custom-select").children("li:not(.init)").toggle();
});

$("ul.custom-select").on("click", "li:not(.init)", function () {
  $(this).parent().children("li:not(.init)").removeClass("selected");
  $(this).addClass("selected");
  $(this).parent().children(".init").html($(this).html());
  $(this).parent().children(".init").removeClass("li-unselected");
  $(this).parent().children("li:not(.init)").toggle();
  if ($("ul.custom-select li.init").hasClass("li-unselected")) {
    $("#add-frequently-bought").prop("disabled", true);
  } else {
    $("#add-frequently-bought").prop("disabled", false);
  }
});
loadedBg();
function loadedBg() {
  window.onload = function () {
    setTimeout(function () {
      var jq = window.jQuery || window.$;
      if (typeof jq === "function") jq(".loading-image").removeClass("loading-image").addClass("loaded-image");
    }, 3000);
  };
}

jQuery(function () {
  jQuery().on("click", function () {
    jQuery("iframe")
      .contents()
      .find("video")
      .each(function () {
        this.currentTime = 0;
        this.pause();
      });
  });
});


document.querySelector(".header-drawer__close").addEventListener("click", closeDrawerMenu);
function closeDrawerMenu() {
  document.querySelector("body").classList.remove("overflow-hidden-tablet");
}

$("#dT_TopStickySearchBtn").click(function (ev) {
  ev.preventDefault();
  $("#dT_top-sticky").addClass("search-show");
  $("#dT_top-sticky .search-modal").css("opacity", "1");
  $("body").addClass("search-overlay-open");
  //FOR Default panel 
    $(".tab_content").hide(); 
	$("ul.panelTabs li:first").addClass("active").show();
	$(".tab_content:first").show(); 
	
	$("ul.panelTabs li").click(function() {
		$("ul.panelTabs li").removeClass("active");
		$(this).addClass("active");
		$(".tab_content").hide();
		var activeTab = $(this).find("a").attr("href");
		$(activeTab).fadeIn();
		return false;
	});
  loadedBg();
});

$(".dT_TopStickySearchCloseBtn").click(function (ev) {
  ev.preventDefault();
  $("#dT_top-sticky").removeClass("search-show");
  $("#dT_top-sticky .search-modal").css("opacity", "0");
  $("body").removeClass("search-overlay-open");
});

setTimeout(function () {
  $("#AccessibleNav .sub-menu-block").show();
}, 1000);



$(document).ready(function () {
  setTimeout(function () {
 document.getElementById("MainContent").classList.remove("placeholder-shadow-blocks");
    }, 1500);
});



$(function() {
  $('.acc__title').click(function(j) {    
    var dropDown = $(this).closest('.dt-sc-tabs-content');
    $(this).closest('dt-sc-tabs-content').not(dropDown).slideUp();    
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
    } else {
      $(this).closest('dt-sc-tabs-content.active').removeClass('active');
      $(this).addClass('active');
    }    
    dropDown.stop(false, true).slideToggle();
    j.preventDefault();
  });
});


$(document).ready(function(){ 
    $('.tablinks').click(function(){  
      $(".dt-sc-tabs-content").removeClass('tab-active-content');
      $(".dt-sc-tabs-content[data-id='"+$(this).attr('data-id')+"']").addClass("tab-active-content");
      $(".tablinks").removeClass('active-tab');     
      $(this).addClass('active-tab');
     });
});


$(document).ready(function () {
  hotSpot();
});
$(window).on("resize", function () {
  hotSpot();
});
function hotSpot() {
    if($(window).width() > 767) 
    {     
      jQuery(function($) {
       $('.dt-sc-hotspot-item').each(function () {
        var pop = $(this).find('.dt-sc-hotspot-popup');
        pop.click(function(e) {
          e.stopPropagation();
        });

        $(this).find('a.dt-sc-hotspot-marker').click(function(e) {
          e.preventDefault();
          e.stopPropagation();        
          // $(this).parent().addClass('open');          
          // $(this).next('.dt-sc-hotspot-popup').toggleClass('dt-sc-popup-open');
          // $(this).parent().siblings().children('.dt-sc-hotspot-popup').removeClass('dt-sc-popup-open');

          $(this).parent().parent().addClass('this-hotspot-in-active');
          // For icons disable 
          if ($(this).hasClass("clicked")) {
          $(this).removeClass("clicked");     
          $('.this-hotspot-in-active').find('a.dt-sc-hotspot-marker').css('opacity','0');  
          $(this).css('opacity','1');   
          $('.dt-sc-hotspot-item').removeClass('open');          
          $('a.dt-sc-hotspot-marker').css('opacity','1'); 
          }
          else
          {
          $(this).addClass("clicked");               
          $('.this-hotspot-in-active').find('a.dt-sc-hotspot-marker').css('opacity','0');  
          $(this).css('opacity','1');     
          $(this).parent().addClass('open');          
          $(this).next('.dt-sc-hotspot-popup').toggleClass('dt-sc-popup-open');
          $(this).parent().siblings().children('.dt-sc-hotspot-popup').removeClass('dt-sc-popup-open');
            }

          // Disable End
          
        });

        $(document).click(function() {
          $('.dt-sc-hotspot-wrapper').removeClass('this-hotspot-in-active');
          pop.removeClass('dt-sc-popup-open');
          $('.dt-sc-hotspot-item').removeClass('open');
          $('a.dt-sc-hotspot-marker').removeClass('clicked');
          $('a.dt-sc-hotspot-marker').css('opacity','1'); 
        });              
      });
  });
    }  

   if($(window).width() < 768) {     
      $('.dt-sc-hotspot-popup').addClass('mfp-hide');
      $('.dt-sc-hotspot-marker').each(function() {
        $(this).magnificPopup({       
        type: 'inline',
        closeOnBgClick: true,
        closeBtnInside: false,
        showCloseBtn: true
        });
      });        
    }    
}

document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll(".swiper-slide").forEach(slide => {
        slide.addEventListener("click", function(event) {
            let link = this.getAttribute("data-slide-link");
            if (link) {
                window.location.href = link;
            }
        });
    });
});

document.addEventListener("DOMContentLoaded", function() {
  // Look for the Shopify product tag element in the page source
  let productTagsElement = document.querySelector("[data-product-tags]");
  
  if (productTagsElement) {
    let productTags = productTagsElement.getAttribute("data-product-tags");

    // If the product has the "custom" tag, hide the kit-info element
    if (productTags && productTags.includes("custom")) {
      let kitInfo = document.querySelector(".kit-info");
      if (kitInfo) {
        kitInfo.style.display = "none";
      }
    }
  }
});



// $(document).ready(function() {
//   //Default Action
// 	$(".predictTab_content").hide(); //Hide all content
// 	$("ul.predictTabs li:first").addClass("active").show(); //Activate first predictTab
// 	$(".predictTab_content:first").show(); //Show first predictTab content
	
// 	//On Click Event
// 	$("ul.predictTabs li").click(function() {
// 		$("ul.predictTabs li").removeClass("active"); //Remove any "active" class
// 		$(this).addClass("active"); //Add "active" class to selected predictTab
// 		$(".predictTab_content").hide(); //Hide all predictTab content
// 		var activeTab = $(this).find("a").attr("href"); //Find the rel attribute value to identify the active predictTab + content
// 		$(activeTab).fadeIn(); //Fade in the active content
// 		return false;
// 	});
// });

document.addEventListener('DOMContentLoaded', function(){
  // Select all accordion headings in the product info section
  var accordionTitles = document.querySelectorAll('.product__info-as-bottom-tabs .accordion__title, .product__info-as-bottom-tabs .acc__title');
  
  accordionTitles.forEach(function(title) {
    title.addEventListener('click', function(){
      // Toggle active class on the clicked title
      title.classList.toggle('active');
      
      // Get the next sibling that is the content panel
      var content = title.nextElementSibling;
      if(content && content.classList.contains('dt-sc-tabs-content')) {
        if(content.style.display === 'block') {
          content.style.display = 'none';
        } else {
          content.style.display = 'block';
        }
      }
      
      // Optionally, close other open panels:
      accordionTitles.forEach(function(otherTitle){
        if(otherTitle !== title) {
          otherTitle.classList.remove('active');
          var otherContent = otherTitle.nextElementSibling;
          if(otherContent && otherContent.classList.contains('dt-sc-tabs-content')) {
            otherContent.style.display = 'none';
          }
        }
      });
    });
  });
});


document.addEventListener("DOMContentLoaded", function() {
  // Use a more specific selector for direct children only
  var headers = document.querySelectorAll('.product__info-as-bottom-tabs > h6.accordion__title');
  console.log("Found accordion headers:", headers);
  
  headers.forEach(function(header, index) {
    var iconContainer = document.createElement("span");
    iconContainer.className = "custom-accordion-icon";
    
    // Choose an icon based on the header index
    switch (index) {
      case 0:
        iconContainer.innerHTML = '<svg fill="#000000" width="24px" height="24px" viewBox="0 0 128 128" id="Layer_1" version="1.1" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g><path d="M64,1C29.3,1,1,29.3,1,64s28.3,63,63,63s63-28.3,63-63S98.7,1,64,1z M64,119C33.7,119,9,94.3,9,64S33.7,9,64,9   s55,24.7,55,55S94.3,119,64,119z"/><rect height="40" width="8" x="60" y="54.5"/><rect height="8" width="8" x="60" y="35.5"/></g></svg>';
        break;
      case 1:
        iconContainer.innerHTML = '<svg fill="#000000" width="24px" height="24px" viewBox="0 -13.54 122.88 122.88" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  style="enable-background:new 0 0 122.88 95.8" xml:space="preserve"><g><path d="M12.14,0H32.8h29.43h28.8h19.71c3.34,0,6.38,1.37,8.58,3.56c2.2,2.2,3.56,5.24,3.56,8.58v7.13v57.25v7.09 c0,3.34-1.37,6.38-3.56,8.58c-2.2,2.2-5.24,3.56-8.58,3.56h-19.2c-0.16,0.03-0.33,0.04-0.51,0.04c-0.17,0-0.34-0.01-0.51-0.04 H62.74c-0.16,0.03-0.33,0.04-0.51,0.04c-0.17,0-0.34-0.01-0.51-0.04H33.31c-0.16,0.03-0.33,0.04-0.51,0.04 c-0.17,0-0.34-0.01-0.51-0.04H12.14c-3.34,0-6.38-1.37-8.58-3.56S0,86.95,0,83.61v-7.09V19.27v-7.13C0,8.8,1.37,5.76,3.56,3.56 C5.76,1.37,8.8,0,12.14,0L12.14,0z M55.19,31.24l20.53,14.32c0.32,0.2,0.61,0.48,0.84,0.81c0.92,1.33,0.58,3.14-0.74,4.06 L55.37,64.57c-0.5,0.41-1.15,0.66-1.85,0.66c-1.62,0-2.93-1.31-2.93-2.93V33.63h0.01c0-0.58,0.17-1.16,0.52-1.67 C52.05,30.64,53.87,30.32,55.19,31.24L55.19,31.24z M93.95,79.45V89.9h16.78c1.73,0,3.3-0.71,4.44-1.85 c1.14-1.14,1.85-2.71,1.85-4.44v-4.16H93.95L93.95,79.45z M88.1,89.9V79.45H65.16V89.9H88.1L88.1,89.9z M59.31,89.9V79.45H35.73 V89.9H59.31L59.31,89.9z M29.87,89.9V79.45H5.85v4.16c0,1.73,0.71,3.3,1.85,4.44c1.14,1.14,2.71,1.85,4.44,1.85H29.87L29.87,89.9z M5.85,73.6H32.8h29.43h28.8h26V22.2h-26h-28.8H32.8H5.85V73.6L5.85,73.6z M88.1,16.35V5.85H65.16v10.49H88.1L88.1,16.35z M93.95,5.85v10.49h23.07v-4.2c0-1.73-0.71-3.3-1.85-4.44c-1.14-1.14-2.71-1.85-4.44-1.85H93.95L93.95,5.85z M59.31,16.35V5.85 H35.73v10.49H59.31L59.31,16.35z M29.87,16.35V5.85H12.14c-1.73,0-3.3,0.71-4.44,1.85c-1.14,1.14-1.85,2.71-1.85,4.44v4.2H29.87 L29.87,16.35z"/></g></svg>';
        break;
      case 2:
        iconContainer.innerHTML = '<svg fill="#000000" height="24px" width="24px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 285.004 285.004" xml:space="preserve"><path color-rendering="auto" image-rendering="auto" shape-rendering="auto" color-interpolation="sRGB" d="M275.141,179.031 c-0.786-0.012-1.565,0.161-2.272,0.506c-5.398,2.543-10.136,2.612-15.756-0.01c-2.483-1.209-5.476-0.176-6.685,2.307 c-1.209,2.483-0.176,5.476,2.307,6.685c0.05,0.024,0.1,0.048,0.151,0.07c7.948,3.705,16.538,3.623,24.244-0.01 c2.514-1.142,3.627-4.106,2.485-6.621c-0.799-1.76-2.542-2.902-4.475-2.932V179.031z M265,196.295c-10,0-20,8.403-20,21.875 c0,9.167,5.215,14.787,8.965,18.537c3.676,3.676,5.914,5.601,6.002,11.168c-0.151,2.175,1.123,4.197,3.15,4.998 c0.003,0,0.007,0,0.01,0c0.029,0.011,0.057,0.021,0.086,0.031c2.223,0.852,4.739,0.019,6.014-1.992 c3.539-3.669,5.794-6.821,6.982-9.793c1.279-3.198,1.295-6.076,1.295-7.951s-0.016-2.746,0.58-4.236c0.596-1.49,2-3.771,5.455-7.227 c0.938-0.938,1.465-2.21,1.465-3.537c0-13.472-10-21.875-20-21.875L265,196.295z M265,206.295c4.656,0,9.258,2.539,9.877,10.168 c-2.936,3.207-5.011,6.081-6.082,8.758c-1.279,3.198-1.295,6.074-1.295,7.949c0,1.713-0.038,2.622-0.49,3.897 c-1.788-3.104-4.063-5.52-5.975-7.432c-3.75-3.75-6.035-5.631-6.035-11.465C255,209.142,260,206.295,265,206.295L265,206.295z  M264.963,31.801c-2.596,0.02-4.745,2.023-4.947,4.611l-10,130c-0.16,2.077,0.984,4.035,2.871,4.916 c7.948,3.705,16.538,3.621,24.244-0.01c1.877-0.885,3.012-2.837,2.853-4.906l-10-130C269.78,33.795,267.588,31.782,264.963,31.801 L264.963,31.801z M265,101.976l4.727,61.443c-3.154,0.941-6.213,0.942-9.451-0.019L265,101.976L265,101.976z M145,177.482 c-13.748,0-25,11.252-25,25s11.252,25,25,25s25-11.252,25-25S158.748,177.482,145,177.482z M145,187.482c8.344,0,15,6.656,15,15 s-6.656,15-15,15s-15-6.656-15-15S136.656,187.482,145,187.482z M75,167.482c-13.748,0-25,11.252-25,25s11.252,25,25,25 s25-11.252,25-25S88.748,167.482,75,167.482z M75,177.482c8.343,0,15,6.656,15,15s-6.657,15-15,15s-15-6.656-15-15 S66.657,177.482,75,177.482z M45,117.482c-13.748,0-25,11.252-25,25s11.252,25,25,25s25-11.252,25-25S58.748,117.482,45,117.482z  M45,127.482c8.343,0,15,6.657,15,15s-6.657,15-15,15s-15-6.656-15-15S36.657,127.482,45,127.482z M85,67.482 c-13.748,0-25,11.252-25,25s11.252,25,25,25s25-11.252,25-25S98.748,67.482,85,67.482z M85,77.482c8.343,0,15,6.656,15,15 s-6.657,15-15,15s-15-6.656-15-15S76.657,77.482,85,77.482z M145,67.482c-13.748,0-25,11.252-25,25s11.252,25,25,25s25-11.252,25-25 S158.748,67.482,145,67.482z M145,77.482c8.344,0,15,6.656,15,15s-6.656,15-15,15s-15-6.656-15-15S136.656,77.482,145,77.482z  M115.787,27.521c-14.705,0-29.513,2.63-43.25,8.088C28.751,53.007-0.011,95.396,0,142.512 c0.011,47.116,28.793,89.489,72.588,106.865s93.8,6.262,126.111-28.029c1.593-1.695,1.806-4.264,0.516-6.199l0.01,0.01 c-24.134-36.368-16.542-61.348-6.562-84.271c4.99-11.462,10.813-22.14,13.473-33.182c2.66-11.042,1.554-22.901-7.213-33.822 c-18.919-23.569-50.783-36.348-83.135-36.357L115.787,27.521z M115.684,37.709c29.628,0.148,58.905,11.832,75.44,32.43 c6.978,8.693,7.492,16.077,5.289,25.221c-2.203,9.144-7.725,19.598-12.92,31.531c-10.073,23.138-17.929,52.873,5.219,90.264 c-29.553,29.182-73.605,38.334-112.434,22.928C36.264,224.206,10.01,185.556,10,142.508C9.989,99.46,36.223,60.798,76.229,44.902 C88.676,39.957,102.216,37.641,115.684,37.709z"/></svg>';
        break;
      case 3:
        iconContainer.innerHTML = '<svg height="24px" width="24px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  viewBox="0 0 401.647 401.647" xml:space="preserve"><g><path d="M377.265,182.958l-25.79-24.429c-2.25-2.132-5.176-3.841-8.4-4.998c-0.839-0.758-1.857-1.343-3.021-1.664l-23.231-6.421 c0.91-1.974,1.711-4.122,2.343-6.486c5.093-19.098-5.296-38.73-23.652-44.695c-2.823-0.917-5.805-1.383-8.864-1.383 c-8.416,0-15.821,3.433-21.012,6.248c-3.287-7.101-9.376-17.62-21.597-21.592c-3.523-1.146-7.186-1.726-10.885-1.726 c-15.125,0-29,9.636-34.526,23.979c-2.258,5.864-2.838,11.266-2.64,15.978c-2.091,0.22-4.077,0.561-5.825,1.034L60.632,151.856 c-0.219,0.059-0.431,0.131-0.64,0.208c-3.782,1.136-7.243,3.023-9.82,5.464l-25.79,24.431c-3.792,3.592-5.474,8.257-4.614,12.797 c0.858,4.541,4.129,8.269,8.971,10.228l26.353,10.66v98.787c0,8.296,5.549,17.439,12.908,21.27l121.444,63.196 c3.409,1.773,7.789,2.751,12.333,2.751c4.543,0,8.923-0.978,12.332-2.751L335.552,335.7c7.359-3.83,12.909-12.974,12.909-21.27 v-98.558l24.447-9.89c4.842-1.959,8.112-5.687,8.971-10.228C382.739,191.216,381.057,186.551,377.265,182.958z M212.627,105.185 c3.312-8.596,11.562-14.371,20.528-14.371c2.122,0,4.225,0.333,6.248,0.991c7.896,2.565,11.678,11.354,13.938,16.606 c1.529,3.554,2.85,6.622,6.574,7.833c0.806,0.262,1.651,0.395,2.514,0.395c0.001,0,0.003,0,0.004,0 c2.679-0.001,4.754-1.175,7.895-2.95c4.088-2.313,10.265-5.806,16.321-5.806c1.503,0,2.886,0.212,4.228,0.648 c10.596,3.443,16.783,15.359,13.796,26.563c-1.521,5.696-4.514,10.002-10.006,14.396c-9.73,7.787-43.593,21.36-52.669,22.03 c-6.556-5.473-26.53-37.147-29.741-48.816C210.394,115.934,210.505,110.693,212.627,105.185z M194.083,131.283 c1.372-0.371,3.132-0.605,5.008-0.719c3.262,8.6,9.98,20.476,15.744,29.559c6.862,10.815,11.738,17.005,15.206,20.606 l-28.264,8.268L95.59,157.935L194.083,131.283z M60.489,168.418c1.542-1.461,4.793-2.563,7.563-2.563 c0.981,0,1.646,0.135,2.032,0.247l119.201,34.87l-27.822,37.112c-0.903,1.206-2.92,2.08-4.796,2.08c-0.627,0-1.2-0.098-1.658-0.283 l-119.101-48.18L60.489,168.418z M74.923,322.394c-2.394-1.245-4.832-5.264-4.832-7.963v-92.719l79.292,32.076 c2.26,0.914,4.71,1.377,7.281,1.377c0.001,0,0.001,0,0.002,0c6.624,0,13.062-3.098,16.799-8.083l20.811-27.76v165.179 L74.923,322.394z M333.461,314.431c0,2.698-2.439,6.717-4.833,7.963l-119.353,62.108v-161.64l18.906,25.219 c3.737,4.986,10.175,8.084,16.8,8.084c2.572,0,5.022-0.463,7.282-1.377l81.197-32.847V314.431z M246.639,240.882 c-0.458,0.186-1.031,0.283-1.657,0.283c-1.876,0-3.894-0.875-4.798-2.081l-27.821-37.111l119.202-34.87 c0.385-0.112,1.05-0.247,2.031-0.247c2.77,0,6.021,1.102,7.563,2.563l24.581,23.283L246.639,240.882z"/><path d="M98.667,95.861c11.674,6.638,47.009,15.439,61.98,15.439c3.467,0,5.898-0.451,7.885-1.463 c1.99-1.014,7.274-3.706,18.173-29.009c4.909-11.399,10.508-26.761,11.498-35.686c0.709-6.386,0.959-16.072-5.03-26.422 C186.488,7.174,174.119,0,160.893,0c-5.646,0-11.045,1.292-16.05,3.842c-11.054,5.632-15.473,17.169-17.682,24.566 c-4.288-1.574-10.05-3.287-16.417-3.287c-5.087,0-9.84,1.106-14.126,3.29C79.42,37.174,72.228,58.19,80.246,76.258 C85.105,87.204,93.086,92.688,98.667,95.861z M103.428,41.776c2.187-1.114,4.58-1.655,7.316-1.655 c5.386,0,10.739,2.132,14.281,3.543c2.664,1.062,4.424,1.762,6.502,1.762c1.312,0,2.552-0.293,3.689-0.872 c3.503-1.786,4.407-5.044,5.552-9.169c1.527-5.503,4.083-14.713,10.884-18.178c2.876-1.465,5.984-2.207,9.24-2.207 c7.891,0,15.286,4.306,19.298,11.236c2.952,5.101,3.881,10.261,3.104,17.253c-1.386,12.486-15.896,46.354-21.6,52.784 c-0.264,0.016-0.608,0.027-1.048,0.027c-12.113,0-45.261-8.188-54.566-13.479c-6.104-3.471-9.73-7.254-12.126-12.649 C89.252,59.573,93.501,46.834,103.428,41.776z"/></g></svg>';
        break;
      case 4:
        iconContainer.innerHTML = '<svg fill="#000000" width="24px" height="24px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M16 0c-8.836 0-16 7.163-16 16s7.163 16 16 16c8.837 0 16.001-7.163 16.001-16s-7.163-16-16.001-16zM16 30.032c-7.72 0-14-6.312-14-14.032s6.28-14 14-14 14.001 6.28 14.001 14-6.281 14.032-14.001 14.032zM14.53 25.015h2.516v-2.539h-2.516zM15.97 6.985c-1.465 0-2.672 0.395-3.62 1.184s-1.409 2.37-1.386 3.68l0.037 0.073h2.295c0-0.781 0.261-1.904 0.781-2.308s1.152-0.604 1.893-0.604c0.854 0 1.511 0.232 1.971 0.696s0.689 1.127 0.689 1.989c0 0.725-0.17 1.343-0.512 1.855-0.343 0.512-0.916 1.245-1.721 2.198-0.831 0.749-1.344 1.351-1.538 1.806s-0.297 1.274-0.305 2.454h2.405c0-0.74 0.047-1.285 0.14-1.636s0.36-0.744 0.799-1.184c0.945-0.911 1.703-1.802 2.277-2.674 0.573-0.87 0.86-1.831 0.86-2.881 0-1.465-0.443-2.607-1.331-3.424s-2.134-1.226-3.736-1.226z"></path></svg>';
        break;
      default:
        iconContainer.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle></svg>';
    }
    
    // Optionally style the icon
    iconContainer.style.marginRight = "0.5rem";
    iconContainer.style.verticalAlign = "middle";
    
    // Prepend the icon to the header
    header.insertBefore(iconContainer, header.firstChild);
  });
});


document.addEventListener("DOMContentLoaded", function () {
    function bindPlayButtons() {
      document.querySelectorAll(".custom-play-button").forEach(function (btn) {
        if (btn.dataset.bound) return;

        btn.addEventListener("click", function () {
          var video = btn.closest(".video-wrapper")?.querySelector("video");
          if (video) {
            // Show native controls
            video.setAttribute("controls", "controls");

            // Start playback
            video.play();

            // Hide custom play button
            btn.style.display = "none";
          }
        });

        btn.dataset.bound = "true";
      });
    }

    // Initial bind
    bindPlayButtons();

    // Re-bind if DOM changes (for accordions or tab reveals)
    const observer = new MutationObserver(bindPlayButtons);
    observer.observe(document.body, { childList: true, subtree: true });
  });



